// extracted by mini-css-extract-plugin
export default {"title":"GdprText_title__tdGxB","text":"GdprText_text__xAX1b"};